// extracted by css-extract-rspack-plugin
export default {"connected-logo":"connected-logo-KdHd_D","connectedLogo":"connected-logo-KdHd_D","disconnect-logo":"disconnect-logo-OMNcZu","disconnectLogo":"disconnect-logo-OMNcZu"};